import React from 'react';

import { patchedStoryblokEditable } from 'apps/urban/utils/patchedStoryblokEditable';

import { createMarkup } from '../../utils/createMarkup/createMarkup';
import { getColorFromStory } from '../../utils/getColorFromStory';
import { PromoBannerWrapper, PromoBannerContainer, PromoBannerText } from './PromoBanner.style';
import { TPromoBannerProps, PromoBannerTextType } from './PromoBanner.types';
import { PromoBannerLink } from './PromoBannerLink/PromoBannerLink';
import { getValidText } from './utils/getValidText';

export const PromoBanner = ({
  blok,
  blok: {
    variant,
    color,
    textDesktop,
    textMobile,
    link,
    entireBannerAsALink,
    textColor,
    backgroundColor,
  },
}: TPromoBannerProps) => {
  const validTextMobile = getValidText(textMobile);

  return (
    <PromoBannerWrapper
      {...patchedStoryblokEditable(blok)}
      color={color}
      backgroundColor={getColorFromStory(backgroundColor)}
    >
      <PromoBannerContainer variant={variant}>
        <PromoBannerText
          dangerouslySetInnerHTML={createMarkup(textDesktop)}
          variant={variant}
          textType={validTextMobile ? PromoBannerTextType.Desktop : PromoBannerTextType.All}
          color={getColorFromStory(textColor)}
        />
        {validTextMobile && (
          <PromoBannerText
            dangerouslySetInnerHTML={createMarkup(validTextMobile)}
            variant={variant}
            textType={PromoBannerTextType.Mobile}
            color={getColorFromStory(textColor)}
          />
        )}
        {link?.map((linkItem) => (
          <PromoBannerLink
            entireBannerAsALink={entireBannerAsALink}
            key={linkItem._uid}
            {...linkItem}
          />
        ))}
      </PromoBannerContainer>
    </PromoBannerWrapper>
  );
};
